/*
Roles.js
角色
 */

import React from 'react';
import {Space, Spin} from 'antd';
import {UserOutlined} from '@ant-design/icons';
import {Prompts} from '@ant-design/x';
import 'katex/dist/katex.min.css'; // 样式

import Point5Icon from "../PointFive/Point5Icon";
import renderMarkdown from "./renderMarkdown";

export const roles = {
    // point5
    point5: {
        placement: 'start', // 位置在左侧
        avatar: {
            icon: <Point5Icon/>,
            style: {
                borderStyle: 'solid',
                borderColor: '#DCDCDC',
                background: '#fff',
            },
        },
        variant: 'shadow',
        loadingRender: () => (
            <Space>
                <Spin size="small"/>
                思考中...
            </Space>
        ),
        styles: {
            content: {
                fontSize: '16px',
            },
        },
        messageRender: renderMarkdown,
    },
    // 用户
    user: {
        placement: 'end', // 位置在右侧
        shape: 'round',
        styles: {
            content: {
                fontSize: '15px',
            },
        },
    },
    // 建议
    suggestion: {
        placement: 'start', // 位置在左侧
        avatar: {
            icon: <UserOutlined/>,
            style: {
                visibility: 'hidden',
            },
        },
        variant: 'borderless',
        messageRender: (items) => <Prompts vertical items={items}/>,
    },
};